module.exports = __webpack_public_path__ + "img/sprinkle-14.248b3483.webp";